import {
  LoadingTemplate,
  SiteAdminClinicInfoFormTemplate,
  SiteAdminNotFoundTemplate,
} from '@/components/templates';
import { useAdminClinicInfoUpdate } from '@/hooks/admin/useAdminClinicInfoUpdate';
import { useSiteAdminClinicInfoDetail } from '@/hooks/admin/useSiteAdminClinicInfoDetail';
import { useQueryClient } from '@tanstack/react-query';
import { useNavigate, useParams } from 'react-router-dom';
import { ClinicCreateFormData, flattenClinicCreateData } from './clinicFormSchema';

const SiteAdminClinicInfoEditPage = () => {
  const { site, id } = useParams<{ site: string; id: string }>();
  const currentSite = site ?? 'medix';
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const { mutateAsync: updateClinicInfo, isPending } = useAdminClinicInfoUpdate();
  const { data: clinicInfoData, isLoading, isError } = useSiteAdminClinicInfoDetail(id!);
  const clinicId = clinicInfoData?.data.clinic_id;

  const breadcrumbItems = [
    {
      title: '治療院詳細',
      href: clinicId
        ? `/${currentSite}/admin/clinics/${clinicId}`
        : `/${currentSite}/admin/clinics`,
    },
    {
      title: ':id',
    },
  ];

  const handleSubmit = async (data: ClinicCreateFormData) => {
    const flattenedData = flattenClinicCreateData(data);
    await updateClinicInfo({
      id: id!,
      data: flattenedData,
    });
    const targetClinicId = flattenedData.clinic_id;
    if (targetClinicId) {
      await queryClient.invalidateQueries({
        queryKey: ['clinic-detail', String(targetClinicId), currentSite],
      });
      navigate(`/${currentSite}/admin/clinics/${targetClinicId}`);
    }
  };

  if (isLoading) return <LoadingTemplate />;

  if (isError) return <SiteAdminNotFoundTemplate />;

  return (
    <main>
      <SiteAdminClinicInfoFormTemplate
        breadcrumbItems={breadcrumbItems}
        onSubmit={handleSubmit}
        isLoading={isPending}
        isEdit={true}
        clinicId={clinicId ? String(clinicId) : undefined}
        clinicInfoData={clinicInfoData?.data}
        site={currentSite}
      />
    </main>
  );
};

export default SiteAdminClinicInfoEditPage;
